  <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18px"
        height="18px"
        viewBox="0 0 24 24">
        <path fill="currentColor" d="m7 10l5 5l5-5z" />
      </svg>